import React from "react";

export default function MultiCrypto() {
  return (
    <div>
      <section className="lg:pt-[100px] py-[50px]">
        <div className="container lg:px-10 px-4">
          <div className="lg:mb-[80px] max-w-[1000px] mx-auto lg:px-10 px-4">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              Multi Wallet Connectivity
            </h3>
            <p className="text-center lg:text-[18px] sm:text-[15px] text-[14px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s,
            </p>
          </div>
          <div className="flex justify-center mt-8">
            <img
              src="/assets/home-banner.png"
              className="lg:h-[500px]  h-[300px]"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
